import { render, staticRenderFns } from "./UserSwitch.vue?vue&type=template&id=0f54b4e7&scoped=true"
import script from "./UserSwitch.vue?vue&type=script&lang=js"
export * from "./UserSwitch.vue?vue&type=script&lang=js"
import style0 from "./UserSwitch.vue?vue&type=style&index=0&id=0f54b4e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f54b4e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
